// Lightweight, dependency-free logging for the cache/connectivity recovery
// flow (stale build detected, auto-reload fired, connectivity state changes).
// The Firestore frontendErrors pipeline (errorLogger.js) isn't on this branch,
// so this logs to console only — swap the implementation if that pipeline
// ever lands here.
export const logRecoveryEvent = (event, meta) => {
  try {
    // eslint-disable-next-line no-console
    console.info(`[webbie-recovery] ${event}`, meta || "");
  } catch (e) {
    /* console unavailable — never let logging break the app */
  }
};
